import { P2GStack, P2GText, SvgFillWarningTriangle } from '@parcel2go/core-ui';

type props = {
  message: string;
  dataTestId?: string;
};

export const ErrorMessage = ({ message, dataTestId }: props) => {
  return (
    <P2GText colour="error" dataTestId={dataTestId}>
      <P2GStack component={'span'} classNames="p2g-error-text" direction="row" gap={1} alignItems="center">
        <span style={{ display: 'flex', flex: '0 0 auto' }}>
          <SvgFillWarningTriangle width={24} height={24} />
        </span>
        <P2GText variant="body2">{message}</P2GText>
      </P2GStack>
    </P2GText>
  );
};
